import { render, staticRenderFns } from "./VisitWrapper.vue?vue&type=template&id=51cdbb23"
import script from "./VisitWrapper.vue?vue&type=script&lang=js"
export * from "./VisitWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51cdbb23')) {
      api.createRecord('51cdbb23', component.options)
    } else {
      api.reload('51cdbb23', component.options)
    }
    module.hot.accept("./VisitWrapper.vue?vue&type=template&id=51cdbb23", function () {
      api.rerender('51cdbb23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/visitRegistry/VisitWrapper.vue"
export default component.exports